export const SketchOrderSortParameter = {
    None: "None",
    AdminPriority: "AdminPriority",
    TechPriority: "TechPriority",
    UpdatedAt: "UpdatedAt",
    TimeSinceRequested: "TimeSinceRequested",
    DueDate: "DueDate",
};
